
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoalibaugtempo() {



    const cardData =
    {
        keyword: 'Pune to Alibaug Tempo Traveller',
        heading: 'Mauli Cabs: Pune to Alibaug Tempo Traveller',
        headingDescription: 'Mauli Cabs offers reliable Pune to Alibaug tempo traveller services, providing a comfortable and spacious ride for family outings, group trips, or corporate events. Our well-maintained tempo travellers are perfect for long-distance journeys, offering ample seating, air conditioning, and a smooth ride. Whether you are planning a relaxing beach getaway or a fun-filled adventure, we ensure your journey to Alibaug is stress-free and enjoyable. With professional drivers, on-time pickups, and transparent pricing with no hidden charges, Mauli Cabs ensures a pleasant travel experience.',

        top: 'Top Places to Visit in Alibaug with Mauli Cabs',

"topPlaces": [
    {
        "title": "Alibaug Beach",
        "description": "A popular beach known for its scenic beauty, black sand, and views of the Kolaba Fort. It’s ideal for sunsets, water sports, and horse cart rides along the shore."
    },
    {
        "title": "Kolaba Fort",
        "description": "Situated in the sea near Alibaug Beach, Kolaba Fort is a 17th-century military fortification accessible during low tide and rich in Maratha history."
    },
    {
        "title": "Kihim Beach",
        "description": "A clean, less crowded beach surrounded by coconut palms and wildflowers, perfect for picnics, photography, and bird watching."
    },
    {
        "title": "Varsoli Beach",
        "description": "A serene and peaceful beach ideal for relaxation. It's less commercialized and great for spending quiet time by the sea."
    },
    {
        "title": "Nagaon Beach",
        "description": "Popular for water sports like jet skiing, banana boat rides, and parasailing, Nagaon Beach is great for adventure lovers and families."
    },
    {
        "title": "Kanakeshwar Forest and Temple",
        "description": "A scenic hilltop temple dedicated to Lord Shiva, located amidst dense forest, offering a tranquil and spiritual escape with panoramic views."
    },
    {
        "title": "Murud-Janjira Fort",
        "description": "Located near Alibaug, this sea fort is famed for being unconquered despite several attempts. It's accessible by boat and known for its strong defense architecture."
    },
    {
        "title": "Akshi Beach",
        "description": "A quiet and clean beach known for its soft sand and shallow waters, ideal for peaceful walks and spotting migratory birds."
    },
    {
        "title": "Revdanda Beach & Fort",
        "description": "Revdanda Beach offers a peaceful retreat, and the adjacent Portuguese-era fort adds a historical touch to the visit."
    },
    {
        "title": "Mandwa Beach",
        "description": "Famous for its ferry terminal connecting to Mumbai, Mandwa Beach also offers water sports, palm-lined shorelines, and clear waters."
    }
],

"services": [
    {
      "name": "Pune To Alibaug Tempo Traveller Hire On Rent",
      "description": "Rent a comfortable Tempo Traveller for your journey from Pune to Alibaug. Perfect for group travel, offering comfort and convenience."
    },
    {
      "name": "Tempo Traveller on Rent for Alibaug",
      "description": "Book a Tempo Traveller for a smooth and comfortable trip from Pune to Alibaug. Ideal for group trips, family outings, and corporate events."
    },
    {
      "name": "Pune to Alibaug Mini Bus on Rent",
      "description": "For large groups, rent a Mini Bus for your trip from Pune to Alibaug. Spacious and comfortable seating ensures a relaxing ride."
    },
    {
      "name": "Hire Pune to Alibaug Bus & Tempo Traveller on Rent",
      "description": "A wide range of buses and Tempo Travellers available for hire for your journey from Pune to Alibaug. Choose the right vehicle based on your group size and preferences."
    },
    {
      "name": "Pune to Alibag Bus Package Tour",
      "description": "Enjoy a one-day or multi-day bus tour package from Pune to Alibaug, including travel, sightseeing, and accommodation options."
    },
    {
      "name": "Pune to Alibaug Tour Package",
      "description": "Book a comprehensive tour package for your trip from Pune to Alibaug, including transportation, accommodation, and guided sightseeing."
    },
    {
      "name": "Pimpri Chinchwad to Alibaug Bus Package",
      "description": "Bus package for residents of Pimpri Chinchwad traveling to Alibaug. Includes travel and sightseeing, perfect for group trips."
    },
    {
      "name": "Pune to Alibaug Package Bus",
      "description": "Customized bus package for groups traveling from Pune to Alibaug, including travel and guided sightseeing."
    },
    {
      "name": "Pune to Alibaug 32, 35, 40, 45 Seater Bus on Rent",
      "description": "Rent large buses (32, 35, 40, or 45 seater) for your group trip from Pune to Alibaug. Ideal for corporate events, school trips, and family vacations."
    },
    {
      "name": "27, 32, 35, 40, 45, 50 Seater Bus On Rent in Pune",
      "description": "Available buses ranging from 27-seater to 50-seater for hire in Pune. Perfect for outstation travel and group tours to Alibaug and nearby destinations."
    },
    {
      "name": "Pune to Konkan Darshan Tempo Traveller on Rent",
      "description": "Book a Tempo Traveller for your Konkan Darshan trip from Pune. Visit beautiful coastal destinations with comfort and ease."
    },
    {
      "name": "Pune Konkan Tour Packages",
      "description": "Customized tour packages to explore Konkan from Pune, including transportation and sightseeing."
    },
    {
      "name": "Pune to Alibaug One Day Trip",
      "description": "A one-day trip package from Pune to Alibaug, including transportation and sightseeing. Perfect for a quick getaway."
    }
  ],
  "tableData": [
    ["Pune To Alibaug Tempo Traveller Hire On Rent", "Tempo Traveller on Rent for Alibaug"],
    ["Pune to Alibaug Mini Bus on Rent", "Hire Pune to Alibaug Bus & Tempo Traveller on Rent"],
    ["Pune to Alibag Bus Package Tour", "Pune to Alibaug Tour Package"],
    ["Pimpri Chinchwad to Alibaug Bus Package", "Pune to Alibaug Package Bus"],
    ["Pune to Alibaug 32, 35, 40, 45 Seater Bus on Rent", "27, 32, 35, 40, 45, 50 Seater Bus On Rent in Pune"],
    ["Pune to Konkan Darshan Tempo Traveller on Rent", "Pune Konkan Tour Packages"],
    ["Pune to Alibaug One Day Trip", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Pune to Alibaug Tempo Traveller",
        "WhyChoosedescription": "Mauli Cabs offers comfortable and spacious Tempo Travellers for your trip from Pune to Alibaug. Whether you’re going for a beach vacation, a family outing, or a group tour, our Tempo Travellers provide a smooth and enjoyable ride."
    },
    {
        "WhyChooseheading": "Perfect for Group Travel to Alibaug",
        "WhyChoosedescription": "Our Tempo Travellers can comfortably accommodate large groups with ample seating, air conditioning, and plenty of luggage space. Travel together in comfort and style on your trip from Pune to Alibaug."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive and affordable pricing for Tempo Traveller rentals from Pune to Alibaug. With no hidden charges, you can enjoy a cost-effective trip with clear and upfront pricing."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Safe Journey",
        "WhyChoosedescription": "Our professional and experienced drivers are familiar with the Pune to Alibaug route, ensuring you reach your destination safely and on time. They prioritize your safety and comfort throughout the journey."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Mauli Cabs is available round the clock for your Pune to Alibaug Tempo Traveller bookings. Whether you need an early morning or late-night departure, we are ready to cater to your needs at any time."
    },
    {
        "WhyChooseheading": "Instant Booking and Real-Time Tracking",
        "WhyChoosedescription": "Booking your Tempo Traveller for a trip from Pune to Alibaug is simple and convenient through our website or app. You can book instantly and track your ride in real-time for a hassle-free experience."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and Secure Vehicles",
        "WhyChoosedescription": "The safety and cleanliness of our passengers are our top priority. Our Tempo Travellers are sanitized regularly, and our drivers adhere to hygiene and safety protocols to ensure a clean and secure travel experience."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Mauli Cabs provides multiple payment options including UPI, credit/debit cards, mobile wallets, and cash, ensuring a smooth and hassle-free payment experience when booking your Tempo Traveller."
    }
]



















    }

    const faqData = [
        {
            question: 'How can I book a Tempo Traveller for a trip from Pune to Alibaug?',
            answer: 'Booking a Tempo Traveller for your Pune to Alibaug trip is simple with Mauli Cabs. Just visit our website or mobile app, select "Tempo Traveller" from the vehicle options, enter your travel details (pickup and destination), and confirm your booking. Our customer support team is available anytime to assist you.',
        },
        {
            question: 'What is the seating capacity of the Tempo Traveller for Pune to Alibaug?',
            answer: 'The Tempo Traveller comes in various seating capacities, ranging from 12 to 17 seats. It’s perfect for larger groups or families traveling to Alibaug, offering plenty of space for passengers and luggage.',
        },
        {
            question: 'Is the fare for the Tempo Traveller fixed for the Pune to Alibaug trip?',
            answer: 'Yes, the fare for the Tempo Traveller from Pune to Alibaug is fixed. The price includes fuel, driver charges, tolls, taxes, and other necessary fees. You will know the total fare before confirming the booking, with no hidden charges.',
        },
        {
            question: 'Can I rent a Tempo Traveller for a round trip from Pune to Alibaug?',
            answer: 'Yes, you can rent a Tempo Traveller for a round trip from Pune to Alibaug. This is a more cost-effective option for those who plan to return to Pune after their trip. The round-trip option ensures a hassle-free return journey.',
        },
        {
            question: 'Is the Tempo Traveller service available 24/7 for Pune to Alibaug?',
            answer: 'Yes, Mauli Cabs offers Tempo Traveller services 24/7 for your Pune to Alibaug trip. Whether you are planning an early morning or late-night departure, you can book the vehicle based on your preferred schedule.',
        },
        {
            question: 'Can I carry extra luggage in the Tempo Traveller for the Pune to Alibaug trip?',
            answer: 'Yes, the Tempo Traveller offers ample luggage space, making it ideal for carrying extra bags or bulky items. It’s a great choice for family vacations or group trips where you need extra space for luggage.',
        },
        {
            question: 'What are the benefits of renting a Tempo Traveller for a Pune to Alibaug trip?',
            answer: 'The Tempo Traveller is perfect for groups and families traveling to Alibaug from Pune. It provides comfortable, spacious seating, air conditioning, and sufficient room for luggage. It’s an ideal vehicle for long-distance group travel, ensuring a smooth and enjoyable ride.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Amit Deshmukh",
            position: "Event Planner",
            text: "We rented a Tempo Traveller for a corporate trip from Pune to Alibaug. The vehicle was very spacious and comfortable for our group of 16. The driver was friendly, and the entire trip was seamless. Highly recommend Mauli Cabs for group travel!",
            image: "/img/testimonial/testimonial-thumb-1-107.png",
        },
        {
            name: "Ms. Rupal Jadhav",
            position: "Tourist",
            text: "I rented a Tempo Traveller for a family trip to Alibaug from Pune. The vehicle was perfect for our group, and the driver ensured a smooth and safe journey. The booking process was easy, and I will definitely choose Mauli Cabs again for future trips!",
            image: "/img/testimonial/testimonial-thumb-1-108.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Alibaug Tempo Traveller",
        "description": "Rent 13 to 50 seater tempo travellers and buses from Pune to Alibaug for a memorable one-day or multi-day trip. Book for group tours, family trips, and corporate events.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "200"
        },
        "offers": {
          "@type": "Offer",
          "url": "https://www.maulicabs.com/pune-to-alibaug-tempo-traveller",
          "priceCurrency": "INR",
          "price": "35",
          "priceValidUntil": "2025-12-31"
        }
      };
      
      
      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Alibaug Tempo Traveller | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book 13 to 50 seater tempo travellers and buses from Pune to Alibaug for a one-day or multi-day tour. Ideal for family trips, group tours, and corporate events."
        />
        <meta
          name="keywords"
          content="Pune to Alibaug Tempo Traveller, tempo traveller hire Alibaug, Alibaug bus rental, Pune to Alibaug tour package, Alibaug one day trip, Alibaug 32 seater tempo traveller"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/137.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoalibaugtempo;